import { render } from "./Assinatura.vue?vue&type=template&id=950aea50&scoped=true"
import script from "./Assinatura.vue?vue&type=script&lang=js"
export * from "./Assinatura.vue?vue&type=script&lang=js"

import "./Assinatura.vue?vue&type=style&index=0&id=950aea50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950aea50"]])

export default __exports__